import type {
  AddToOrderRequest,
  BulkCreateOrderRequest,
  DocumentOrderItem,
} from '@/types/doc';
import axios from './utils/axios';
import generateCRUDOps from './utils/generateCrud';
const pathPrefix = `/documents/`;

const OrderedDocumentService = {
  ...generateCRUDOps(pathPrefix, 'ordered'),

  // Add single document to order
  addToOrder: async (request: AddToOrderRequest) => {
    return axios.post(`${pathPrefix}ordered/`, request);
  },

  // Bulk create ordered documents
  bulkCreateOrder: async (requests: BulkCreateOrderRequest) => {
    return axios.post(`${pathPrefix}ordered/bulk-create/`, requests);
  },

  // Bulk reorder documents
  bulkReorder: async (documentOrders: DocumentOrderItem[]) => {
    return axios.post(`${pathPrefix}ordered/bulk-reorder/`, {
      document_orders: documentOrders,
    });
  },
};

export default OrderedDocumentService;
